// context/user.context.ts

import { createContext } from "@lit/context";
import type { User } from "@/types";

export interface UserContextValue {
  user: User | null;
  identifier: string | null;
}

export const userContext = createContext<UserContextValue>("sb-user-context");
